// extracted by mini-css-extract-plugin
module.exports = {"page":"page___V6CTn","container":"container___2k45z","pageTitle":"pageTitle___2VINt","list":"list___1POFK","moduleTitle":"moduleTitle___2r07K"};